/**
 * The frame of a page that sits beside Home's sidebar (agents, skills): it
 * keeps the organization in the URL the active tenant, as the command center
 * and usage pages do, then renders the page.
 *
 * @module components/home/HomePageRoute
 */
import { useEffect, type ReactNode } from "react";

import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../../state/orgs";

export function HomePageRoute({ children }: { readonly children: ReactNode }) {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);
  return <>{children}</>;
}
